import React, { useEffect, useState } from 'react';

const GA_ID = 'G-J33S3H6GKG';
const CONSENT_KEY = 'analytics-consent';

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

function loadGA() {
  if (document.getElementById('ga-script')) return;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA_ID, { anonymize_ip: true });
  const s = document.createElement('script');
  s.id = 'ga-script';
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
}

function getConsent(): string | null {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch {
    return null;
  }
}

function setConsent(value: 'granted' | 'denied') {
  try {
    localStorage.setItem(CONSENT_KEY, value);
  } catch {
    /* private mode — session-only choice */
  }
}

const Analytics: React.FC = () => {
  const [decided, setDecided] = useState<boolean>(() => getConsent() !== null);

  useEffect(() => {
    if (getConsent() === 'granted') loadGA();
  }, []);

  const answer = (yes: boolean) => {
    setConsent(yes ? 'granted' : 'denied');
    setDecided(true);
    if (yes) loadGA();
  };

  if (decided) return null;

  return (
    <div className="consent-bar" role="dialog" aria-label="Analytics consent">
      <span className="consent-bar__prompt">
        <span className="consent-bar__ps1">$</span> allow anonymous visit stats? no cookies for ads, ever.
      </span>
      <span className="consent-bar__actions">
        <button className="consent-bar__btn consent-bar__btn--yes" onClick={() => answer(true)}>
          [y]es
        </button>
        <button className="consent-bar__btn" onClick={() => answer(false)}>
          [n]o
        </button>
      </span>
    </div>
  );
};

export default Analytics;
